export const buildDiscussionImageUploadFormData = (file, companyFolderId) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("companyFolderId", companyFolderId);
  return formData;
};
